import { Component, h, Prop, Element, Host } from '@stencil/core';

export interface AhaIcon extends HTMLAhaIconElement {}

/**
 * The `aha-icon` component supports icons from Font Awesome and the custom-made Aha! icon library.
 */
@Component({
  tag: 'aha-icon',
  styleUrl: 'aha-icon.css',
  shadow: true,
})
export class AhaIcon {
  @Element() host!: HTMLAhaIconElement;

  /**
   * Icon to display in the aha-icon component.
   */
  @Prop() icon: string = '';

  render() {
    const iconClasses = this.icon.match(/aha-icon/) ? `aha-icon ${this.icon}` : this.icon;
    return (
      <Host>
        <i class={iconClasses}></i>
      </Host>
    );
  }
}
